import React from 'react';
import BgFooter from '../../../assets/images/bg-footer.svg';
import PhoneFooter1 from '../../../assets/images/phone-footer1.svg';
import PhoneFooter2 from '../../../assets/images/phone-footer2.svg';
import Fb from '../../../assets/images/fb.svg';
import Instagram from '../../../assets/images/instagram.svg';
import Youtube from '../../../assets/images/youtube.svg';
import Linkedin from '../../../assets/images/sns-linkedin.png';
import WhyNot from '../../../assets/images/footer/why-not.png';

import logo_caring from '../../../assets/images/footer/logo_caring.png';
import logo_irsfmc from '../../../assets/images/footer/logo_irsfmc.png';
import logo_lmla from '../../../assets/images/footer/logo_lmla.png';
import logo_LBA from '../../../assets/images/footer/logo_LBA.png';
import logo_happycompany from '../../../assets/images/footer/logo_happycompany.png';
import logo_healthy_wp from '../../../assets/images/footer/logo_healthy_wp.png';
import logo_mhfo from '../../../assets/images/footer/logo_mhfo.png';
import logo_rdc from '../../../assets/images/footer/logo_rdc.jpg';
import go_greenorg from '../../../assets/images/footer/go_greenorg.png';
import logo_enw from '../../../assets/images/footer/logo_enw.png';
import logo_wawi from '../../../assets/images/footer/logo_wawi.png';
import logo_hkaee from '../../../assets/images/footer/logo_hkaee.png';
import logo_good_employeer from '../../../assets/images/footer/logo_good_employeer.png';

function AppFooter() {
  return (
    <>
      {
        //window.location.href.includes('money-hero') ? MoneyHeroFooter() : MainFooter()
        MoneyHeroFooter()
      }
    </>
  );
}

function MainFooter() {
  return (

    <div className="text-primary2 p-5 pt-20 bg-cover mt-10" style={{ backgroundImage: `url(${BgFooter})` }}>
      <div className="flex items-center justify-center mb-10">
        <div className="px-2">
          <a href="tel:23668859">
            <img src={PhoneFooter1} alt="" />
          </a>
        </div>
        <div className="px-2">
          <a href="tel:31557600">
            <img src={PhoneFooter2} alt="" />
          </a>
        </div>
      </div>
      <div className="flex items-center justify-center space-x-4 mb-5 pb-10 border-b border-white">
        <a href="https://www.facebook.com/cashingpro">
          <img src={Fb} alt='' />
        </a>
        <a href="https://www.instagram.com/cashingpro_hk">
          <img src={Instagram} alt='' />
        </a>
        <a href="https://www.youtube.com/channel/UCsQTED5pE9QL8tZ2V_46NIw">
          <img src={Youtube} alt='' />
        </a>
      </div>
      <div className="py-2 text-white">
        <p className="text-center my-4 font-bold text-xl px-2">忠告 : 借錢梗要還 ，咪俾錢中介。 </p>
        <p className="text-center text-sm">
          投訴熱線：3155-7600 / 放債人牌照號碼：1285/2026
        </p>
      </div>
    </div>

  )
}

function MoneyHeroFooter() {
  return (
    <>
      {/* <div className="text-primary2 p-5 pt-20 bg-cover mt-10" style={{ backgroundImage: `url(${BgFooter})` }}>
        <div className='text-white flex flex-col justify-center lg:mt-16 lg:px-36'>
          <div className='flex flex-col space-y-1 text-[#E7DAFF]'>
            <p>有關「特快貸款批核」只適用於收到申請者的信貸報告後計出貸款初步批核金額的所需時間。申請者須符合指定要求，實際所需時間或會因個別情況而有所不同。</p>
            <p>• 本公司恕不接受以下人士的貸款申請：</p>
            <div className='pl-4 flex space-y-1 flex-col md:text-justify'>
              <p>• 破產申請中、破產中人士破產申請中、破產中人士</p>
              <p>• 曾經有刑事犯罪及民事訴訟紀錄或申請時有刑事及民事審訊進行中之人士</p>
              <p>• 過去及近期信貸報告有撇帳紀錄之人士</p>
            </div>
            <p className='pt-1 md:text-justify'>• 所有批核結果乃根據客戶申請時遞交之資料及文件而得出，Cashing Pro Limited保留貸款批核及任何爭議之最終決定權。</p>
            <p className='pt-1 md:text-justify'>• 貸款產品資料概要:</p>
            <div className='pl-4 flex space-y-1 flex-col md:text-justify'>
              <p>• 最高實際年利率：47.8%</p>
              <p>• 還款期：一般為最短3個月至最長60個月，客戶可自行決定</p>
              <p>• 提早還款沒有任何罰息及手續費</p>
            </div>
            <p className='pt-1 md:text-justify'>• 當客戶每月繳款多於最低還款金額時，利息會因應本金減少而逐漸減少。</p>
            <p className='pt-1'>請參考以下貸款例子：</p>
            <p>假設陳先生成功貸款$10,000，年利率為12%，第一期還款日是取得貸款後的第30天，第一期的利息是$99 (取至整數)。如果陳先生在90日清還貸款，總貸款金額為$10,297，當中總貸款成本（總利息支出）為$297。了解更多</p>
            <a className="text-primary hover:opacity-75" href={`${process.env.REACT_APP_HOME_URL}/flexible-interest-saving-loan-tips/`}>Cashing Pro彈性還款方案。</a>
          </div>
          <div className="flex space-x-4 mb-5 pt-10 pb-4">
            <a href="https://www.facebook.com/cashingpro">
              <img width={51} src={Fb} alt='' />
            </a>
            <a href="https://www.instagram.com/cashingpro_hk">
              <img width={51} src={Instagram} alt='' />
            </a>
            <a href="https://www.youtube.com/channel/UCsQTED5pE9QL8tZ2V_46NIw">
              <img width={51} src={Youtube} alt='' />
            </a>
            <a href="https://www.linkedin.com/company/cashingproltd/">
              <img width={51} src={Linkedin} alt='' />
            </a>
          </div>
        </div>
      </div>
      <div className="flex items-center pt-8 px-5 lg:px-36 flex-wrap justify-center">
        <div className="w-1/3 flex justify-center px-2 lg:w-[calc(100%/7)]">
          <img src={logo_caring} alt='Caring Company' />
        </div>
        <div className="w-1/3 flex justify-center px-2 lg:w-[calc(100%/7)]">
          <img src={logo_irsfmc} alt='Industry Regulatory Scheme for Marketing Calls' />
        </div>
        <div className="w-1/3 flex justify-center px-2 lg:w-[calc(100%/7)]">
          <img src={logo_lmla} alt='LICENSED MONEY LENDERS ASSOCIATION LTD.' />
        </div>
        <div className="w-1/3 flex justify-center px-2 lg:w-[calc(100%/7)]">
          <img src={logo_LBA} alt='' />
        </div>
        <div className="w-1/3 flex justify-center px-2 lg:w-[calc(100%/7)]">
          <img className="max-w-[80px] lg:max-w-[130px]" src={logo_happycompany} alt='' />
        </div>
        <div className="w-1/3 flex justify-center px-2 lg:w-[calc(100%/7)]">
          <img src={logo_healthy_wp} alt='' />
        </div>
        <div className="w-1/3 flex justify-center px-2 lg:w-[calc(100%/7)]">
          <img className="max-w-[80px] lg:max-w-[130px]" src={logo_good_employeer} alt='' />
        </div>
        <div className="w-1/3 flex justify-center px-2 lg:w-[calc(100%/7)]">
          <img src={logo_mhfo} alt='' />
        </div>
        <div className="w-1/3 flex justify-center px-2 lg:w-[calc(100%/7)]">
          <img src={logo_rdc} alt='' />
        </div>
        <div className="w-1/3 flex justify-center px-2 lg:w-[calc(100%/7)]">
          <img src={go_greenorg} alt='' />
        </div>
        <div className="w-1/3 flex justify-center px-2 lg:w-[calc(100%/7)]">
          <img src={logo_enw} alt='' />
        </div>
        <div className="w-1/3 flex justify-center px-2 lg:w-[calc(100%/7)]">
          <img src={logo_wawi} alt='' />
        </div>
        <div className="w-1/3 flex justify-center px-2 lg:w-[calc(100%/7)]">
          <img src={logo_hkaee} alt='' />
        </div>
      </div> */}
      <div className="flex flex-col justify-center items-center pb-6">
        <img src={WhyNot} className="my-4" alt=''/>
        <div className="flex flex-col space-y-2 justify-center items-center">
          <p className="text-[#655288]">投訴熱線：3155 7600   放債人牌照號碼：1285/2026</p>
          <p className="text-[#655288]">© {new Date().getUTCFullYear()} Cashing Pro Limited 版權所有</p>
        </div>
      </div>
    </>
  )
}

export default AppFooter;
